import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './Toggle.module.scss';

export const Toggle = ({
  name,
  className,
  inputProps,
  disabled = false,
  dataTestId,
  small = false,
  register = () => {},
}) => {
  const isControlled = inputProps?.onChange != null && inputProps?.checked !== undefined;

  return (
    <div className={cn(styles.slider, { [className]: className, [styles.small]: small })}>
      <input
        disabled={disabled}
        type="checkbox"
        {...(isControlled ? {} : register(name))}
        {...inputProps}
        data-testid={dataTestId}
      />
      <span></span>
    </div>
  );
};

Toggle.propTypes = {
  register: PropTypes.func,
  name: PropTypes.string,
  className: PropTypes.string,
  inputProps: PropTypes.object,
};
